import { ILLTeachersGuide } from '../../../../../entities/lingoLiftLesson';

export const  isTeacherGuideFilled = (guide: ILLTeachersGuide) => {
  return ((guide?.afterViewing?.length || guide?.afterViewingCustom.length) ||
    (guide?.beforeViewing?.length || guide?.beforeViewingCustom?.length) ||
    (guide?.duringViewing?.length || guide?.duringViewingCustom?.length))
}
